export function sopValorMensal(sopMeio: number, fxRate: number, spread: number): number {
  return (sopMeio * fxRate * spread) / 4 / 12;
}
